import type { Appearance } from "@stripe/stripe-js";

export const appearanceA: Appearance = {
    labels: "floating",
    variables: {
        spacingGridRow: "12px",
        spacingGridColumn: "12px",
        spacingUnit: "4px",
        spacingTab: "4px",
        colorDanger: "#b40000",
        colorPrimary: "#11a9e2",
        colorPrimaryText: "#11a9e2",
        colorText: "#222",
        colorTextSecondary: "#666",
        colorTextPlaceholder: "#999",
        fontFamily: "Source Sans Pro",
        fontWeightNormal: "400",
        fontWeightBold: "600",
        fontSizeBase: "16px",
        fontSizeSm: "14px",
        borderRadius: "0"
    },
    rules: {
        ".Input": {
            fontSize: "var(--fontSizeBase)",
            lineHeight: "1.15",
            letterSpacing: "-0.01em",
            padding: "3px 0 7px",
            boxShadow: "none",
            border: `none`,
            color: "var(--colorTextSecondary)",
            borderBottom: "1px solid #d0d0d0"
        },
        ".Input:focus": {
            boxShadow: "none",
            outline: "none",
            borderBottom: "1px solid var(--colorPrimary)",
        },
        ".Input--invalid": {
            borderBottom: "1px solid var(--colorDanger)",
            color: "var(--colorText)",
            boxShadow: "none",
        },
        ".Input:hover": {
            boxShadow: "none",
            borderBottom: "1px solid #333",
        },
        ".Label": {
            fontSize: "var(--fontSizeBase)",
            lineHeight: "18px",
            letterSpacing: "-0.01em",
            color: "var(--colorTextSecondary)",
            margin: "4px 0 7px"
        },
        ".Label--floating": {
            fontSize: "var(--fontSizeSm)",
            lineHeight: "16px",
            opacity: "1",
            margin: "-2px 0 0",
            padding: "0",
            transition: "all 300ms cubic-bezier(0.5, 0, 0.2, 1)",
            color: "var(--colorTextSecondary)",
        },
        ".Error": {
            fontSize: "12px",
            lineHeight: "15px",
            color: "var(--colorDanger)"
        },
        ".TermsText": {
            fontSize: "14px",
            lineHeight: "1.6",
            letterSpacing: "-0.02em",
            color: "var(--colorTextSecondary)",
            marginTop: "0px"
        }
    }
};

export const appearanceB: Appearance = {
    labels: "floating",
    variables: {
        fontFamily: "Source Sans Pro, sans-serif",
        borderRadius: "1px",
        colorPrimary: "#11a9e2",
        colorDanger: "#ff0000",
        colorText: "#666",
        colorTextPlaceholder: "#666",
        fontSizeBase: "14px",
        spacingGridRow: "15px",
        spacingGridColumn: "10px"
    },
    rules: {
        ".Tab": {
            display: "none"
        },
        ".TabContainer": {
            display: "none"
        },

        ".Input": {
            border: "1px solid rgba(238, 238, 238, 0.85)",
            display: "flex",
            height: "40px",
            padding: "8px 10px",
            alignItems: "center",
            gap: "5px",
            alignSelf: "stretch"
        },
        ".Input--empty": {
            color: "#888",
            display: "flex",
            height: "40px",
            padding: "8px 10px",
            alignItems: "center",
            gap: "5px",
            alignSelf: "stretch"
        },
        ".Input:focus": {
            boxShadow: "0 0 0px 1px #11a9e2",
            borderColor: "#11a9e2"
        },
        ".Input:focus:hover": {
            boxShadow: "0 0 0px 1px #11a9e2",
            borderColor: "#11a9e2"
        },
        ".Input--invalid": {
            boxShadow: "0 0 0px 1px #FF4500",
            borderColor: "#FF4500"
        },
        ".Input:hover": {
            borderColor: "#ddd"
        },

        ".Row": {
            display: "flex",
            gap: "10px",
            marginBottom: "15px"
        },
        ".Row--half": {
            display: "flex",
            gap: "10px",
            marginBottom: "15px"
        },
        ".Label--empty": {
            display: "none"
        },
        ".Label": {
            display: "none"
        }
    }
};

export const defaultAppearance: Appearance = {
    variables: {
        fontFamily: "Source Sans Pro, sans-serif",
        borderRadius: "0px",
        colorPrimary: "#11a9e2",
        colorDanger: "#ff0000"
    },
    rules: {
        ".Input": {
            borderColor: "#c4c4c4",
            transition: "none"
        },
        ".Input:focus": {
            boxShadow: "0 0 0px 1px #11a9e2",
            borderColor: "#11a9e2"
        },
        ".Input:focus:hover": {
            boxShadow: "0 0 0px 1px #11a9e2",
            borderColor: "#11a9e2"
        },
        ".Input--invalid": {
            boxShadow: "0 0 0px 1px #ff0000",
            borderColor: "#ff0000"
        },
        ".Input:hover": {
            borderColor: "#333"
        },
    }
};
